// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetWidgetClassesRequestModel from '../../model/get-widget-classes-request-model';
import GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel from '../../model/get-widget-registration-marketing-questions-definition-request-model';
import GetWidgetSubjectAreasRequestModel from '../../model/get-widget-subject-areas-request-model';
import GetWidgetClassRegistrationQuestionsDefinitionRequestModel from '../../model/get-widget-class-registration-questions-definition-request-model';
import WidgetClassRegisterRequestRequestModel from '../../model/widget-class-register-request-request-model';
import GetWidgetClassInfoRequestModel from '../../model/get-widget-class-info-request-model';
import GetWidgetClassNativeLanguageLookupRequestModel from '../../model/get-widget-class-native-language-lookup-request-model';
import DownloadPdfRequestModel from '../../model/download-pdf-request-model';
import WidgetUploadDocumentRequestModel from '../../model/widget-upload-document-request-model';
import WidgetClassListPagingResultModel from '../../model/widget-class-list-paging-result-model';
import DynamicFormDefinitionModel from '../../model/dynamic-form-definition-model';
import SubjectAreaListResultModel from '../../model/subject-area-list-result-model';
import WidgetClassInformationModel from '../../model/widget-class-information-model';
import Int32LookupListResultModel from '../../model/int32-lookup-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getWidgetClasses(request: GetWidgetClassesRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetClassesRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-classes'] ?? 'WidgetClasses';
    const response = await service.post<any>(endpointPath, {
      body: {
        searchCriteria: requestDTO.searchCriteria,
        paging: requestDTO.paging,
        toccoFilter: requestDTO.toccoFilter,
        searchTag: requestDTO.searchTag,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(WidgetClassListPagingResultModel.toModel(dto));
  },
  /**  */
  async getWidgetRegistrationMarketingQuestionsDefinition(request: GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-registration-marketing-questions-definition'] ?? 'WidgetClasses/{id}/RegistrationMarketingQuestions/Definition';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DynamicFormDefinitionModel.toModel(dto));
  },
  /**  */
  async getWidgetSubjectAreas(request: GetWidgetSubjectAreasRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-subject-areas'] ?? 'WidgetClasses/SubjectAreas';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SubjectAreaListResultModel.toModel(dto));
  },
  /**  */
  async getWidgetClassRegistrationQuestionsDefinition(request: GetWidgetClassRegistrationQuestionsDefinitionRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetClassRegistrationQuestionsDefinitionRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-class-registration-questions-definition'] ?? 'WidgetClasses/{id}/RegistrationQuestions/Definition';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(DynamicFormDefinitionModel.toModel(dto));
  },
  /**  */
  async widgetClassRegisterRequest(request: WidgetClassRegisterRequestRequestModel, config?: RequestConfig) {
    const requestDTO = WidgetClassRegisterRequestRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-widget-class-register-request'] ?? 'WidgetClasses/{id}/Register';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.post<any>(endpointPath, {
      body: {
        eventId: requestDTO.eventId,
        contactAddress: requestDTO.contactAddress,
        invoiceAddress: requestDTO.invoiceAddress,
        correspondenceAddress: requestDTO.correspondenceAddress,
        registrationAnswers: requestDTO.registrationAnswers,
        assessmentProfessionalSuitabilityDocumentId: requestDTO.assessmentProfessionalSuitabilityDocumentId,
        hasDyslexia: requestDTO.hasDyslexia,
        dyslexiaCertificateDocumentId: requestDTO.dyslexiaCertificateDocumentId,
        hasAdhd: requestDTO.hasAdhd,
        adhdCertificateDocumentId: requestDTO.adhdCertificateDocumentId,
        isForeignLanguage: requestDTO.isForeignLanguage,
        toccoNativeLanguageId: requestDTO.toccoNativeLanguageId,
        schoolEducationCountry: requestDTO.schoolEducationCountry,
        hasVisualImpairment: requestDTO.hasVisualImpairment,
        visualImpairmentCertificateDocumentId: requestDTO.visualImpairmentCertificateDocumentId,
        hasHearingImpairment: requestDTO.hasHearingImpairment,
        hearingImpairmentCertificateDocumentId: requestDTO.hearingImpairmentCertificateDocumentId,
        hasOtherDisabilities: requestDTO.hasOtherDisabilities,
        otherDisabilitiesComment: requestDTO.otherDisabilitiesComment,
        employmentPosition: requestDTO.employmentPosition,
        employmentArea: requestDTO.employmentArea,
        employmentGradePercent: requestDTO.employmentGradePercent,
        employmentStartDate: requestDTO.employmentStartDate,
        comment: requestDTO.comment,
        marketingAnswers: requestDTO.marketingAnswers,
        requestSummary: requestDTO.requestSummary,
        acceptNewsletter: requestDTO.acceptNewsletter,
        acceptGdpr: requestDTO.acceptGdpr,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getWidgetClassInfo(request: GetWidgetClassInfoRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetClassInfoRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-class-info'] ?? 'WidgetClasses/ClassInformation';
    const response = await service.post<any>(endpointPath, {
      body: {
        classTypeKey: requestDTO.classTypeKey,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(WidgetClassInformationModel.toModel(dto));
  },
  /**  */
  async getWidgetClassNativeLanguageLookup(request: GetWidgetClassNativeLanguageLookupRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetClassNativeLanguageLookupRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-class-native-language-lookup'] ?? 'WidgetClasses/NativeLanguageLookup';
    const response = await service.get<any>(endpointPath, {
      query: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int32LookupListResultModel.toModel(dto));
  },
  /**  */
  async downloadPdf(request: DownloadPdfRequestModel, config?: RequestConfig) {
    const requestDTO = DownloadPdfRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-download-pdf'] ?? 'WidgetClasses/DownloadPdf';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      body: {
        classTypeKey: requestDTO.classTypeKey,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
  /**  */
  async widgetUploadDocument(request: WidgetUploadDocumentRequestModel, config?: RequestConfig) {
    const requestDTO = WidgetUploadDocumentRequestModel.toDTO(request);
    const formData = new FormData();
    formData.append('uploadFile', requestDTO.uploadFile as Blob);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-widget-upload-document'] ?? 'WidgetClasses/{id}/DocumentUpload';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.post<any>(endpointPath, {
      body: formData,
      headers: {
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as string | undefined);
  },
});
